import { z } from "zod";

export const MAX_CHAT_ATTACHMENTS = 4;
export const MAX_CHAT_ATTACHMENT_BYTES = 10 * 1024 * 1024;
const MAX_CHAT_ATTACHMENT_BASE64_CHARS = Math.ceil((MAX_CHAT_ATTACHMENT_BYTES * 4) / 3) + 4;

export const CHAT_IMAGE_MIME_TYPES = [
	"image/jpeg",
	"image/png",
	"image/gif",
	"image/webp",
] as const;

export const chatAttachmentInputSchema = z.object({
	filename: z.string().trim().min(1).max(255),
	mimeType: z.enum(CHAT_IMAGE_MIME_TYPES),
	data: z.string().min(1).max(MAX_CHAT_ATTACHMENT_BASE64_CHARS),
});

export type ChatAttachmentInput = z.infer<typeof chatAttachmentInputSchema>;

export const chatRequestSchema = z.object({
	message: z.string().min(1),
	conversationId: z.string().uuid().optional(),
	attachments: z.array(chatAttachmentInputSchema).max(MAX_CHAT_ATTACHMENTS).optional(),
	env: z.record(z.string(), z.string()).optional(),
});

export type ChatRequest = z.infer<typeof chatRequestSchema>;

export const conversationSchema = z.object({
	id: z.string().uuid(),
	workspaceId: z.string().uuid(),
	profileId: z.string().uuid(),
	title: z.string().nullable(),
	model: z.string(),
	metadata: z.record(z.unknown()),
	messageCount: z.number(),
	totalTokens: z.number(),
	lastMessageAt: z.string().datetime().nullable(),
	createdAt: z.string().datetime(),
	updatedAt: z.string().datetime(),
});

export type Conversation = z.infer<typeof conversationSchema>;
